import React from "react";
import { MainLayout } from "../../components/MainLayout";
import { useTranslation } from "react-i18next";
import { SummaryCard } from "../../components/SummaryCard";
import taxPayers from "../../assets/img/taxPayers.png";
import taxCash from "../../assets/img/taxCash.png";
import taxInvoices from "../../assets/img/taxInvoices.png";
import { SearchTable } from "../../components/SearchTable";
import { ExportReport } from "../../components/ExportReport";
import { TotalRegisteredDisplay } from "../../components/TotalRegisteredDisplay";
import "./Dashboard.styles.scss";

const Dashboard = ({
  tab,
  statistics,
  onSearchHandler,
  onDownloadReport,
  totalRegistered,
}) => {
  const { t } = useTranslation();
  
  const overviews = [
    {
      title: t("overview.numberOfTaxpayers"),
      value: statistics.numberOfTaxpayers || 0,
      iconUrl: taxPayers,
    },
    {
      title: t("overview.submittedInvoices"),
      value: statistics.numberOfSubmittedInvoices || 0,
      iconUrl: taxInvoices,
    },
    {
      title: t("overview.collectedTaxes"),
      value: `${statistics.totalTaxes || 0} JOD`,
      iconUrl: taxCash,
    },
  ];

  return (
    <MainLayout tab={tab} withSidebar={true}>
      <div className="dashboard-page">
        {/* Professional Overview Section */}
        <div className="overviewSection">
          <h2 className="sectionTitle">{t("overview.title")}</h2>
          <div className="cards">
            {overviews.map((item, index) => (
              <SummaryCard
                key={`overview-card-${index}`}
                className="cardItem"
                title={item.title}
                value={item.value}
                icon={item.iconUrl}
              />
            ))}
          </div>
        </div>

        {/* Professional Search and Export Section */}
        <div className="dashboard-actions">
          <div className="actions-header">
            <SearchTable
              placeholder={t("taxpayers.searchPlaceholder")}
              onSearchHandler={onSearchHandler}
              isTaxPayerPage={true}
            />
            <ExportReport
              label="Download as Excel"
              onClickHandler={onDownloadReport}
            />
          </div>
        </div>

        {/* Professional Results Section */}
        <div className="dashboard-results">
          {totalRegistered === 0 ? (
            <div className="no-registered-taxpayers">
              No registered taxpayers found for this period.
              <div style={{ 
                fontSize: '0.95rem', 
                marginTop: '1rem', 
                opacity: 0.8, 
                fontWeight: 500 
              }}>
                Try adjusting your search criteria or date range to find results.
              </div>
            </div>
          ) : totalRegistered > 0 ? (
            <TotalRegisteredDisplay totalRegistered={totalRegistered} />
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem 2rem', 
              color: '#64748b',
              fontSize: '1.125rem',
              fontWeight: 500 
            }}>
              <div style={{ 
                fontSize: '3rem', 
                marginBottom: '1rem', 
                opacity: 0.6 
              }}>
                🔍
              </div>
              <div>Loading registration data...</div>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default React.memo(Dashboard);